import { keepPreviousData, useQuery } from "@tanstack/react-query";

import type { ISiteTag } from "app/pages/sales-intelligence/domain/leads/types/website";
import { siQueryKeyFactory } from "app/pages/sales-intelligence/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const MIN_SEARCH_TERM_LENGTH = 1;

function useSiteTagsAutocompleteQuery<TData = readonly ISiteTag[] | undefined>(
    searchTerm: string,
    size: number,
    select?: (data: readonly ISiteTag[] | undefined) => TData,
) {
    const isEnabled = searchTerm.length >= MIN_SEARCH_TERM_LENGTH;

    return useQuery<readonly ISiteTag[] | undefined, Error, TData>({
        enabled: isEnabled,
        queryKey: siQueryKeyFactory.siteTagsAutocomplete(searchTerm, size),
        placeholderData: keepPreviousData,
        select: (data) => {
            const gated = isEnabled ? data : undefined;

            return (select ? select(gated) : gated) as TData;
        },
        queryFn: ({ signal }) => {
            return salesApiService.fetchSiteTags(searchTerm, size, { cancellation: signal });
        },
    });
}

export default useSiteTagsAutocompleteQuery;
